import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { useParams } from 'react-router-dom'
import { YStack } from 'tamagui'

import { useScreenMessages } from '@data/i18n'

import { UserMetadata } from '@newComponents/User/UserMetadata'

import { UserPresentationsScreenUpcomingPresentationsSection } from './UserPresentationsScreenUpcomingPresentationsSection'
import { UserPresentationsScreenOtherPresentationsSection } from './UserPresentationsScreenOtherPresentationsSection'

import { UserPresentationsScreenQuery } from './__generated__/UserPresentationsScreenQuery.graphql'

export const UserPresentationsScreen = () => {
  useScreenMessages(
    (locale) =>
      import(
        /* webpackChunkName: "locale-user-presentations-screen-[request]" */ `./locales/${locale}.po`
      )
  )
  const params = useParams()

  const data = useLazyLoadQuery<UserPresentationsScreenQuery>(
    graphql`
      query UserPresentationsScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on User {
            firstName
            lastName

            ...UserMetadata_user
            ...UserPresentationsScreenUpcomingPresentationsSection_user
            ...UserPresentationsScreenOtherPresentationsSection_user
          }
        }
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'User') {
    return null
  }

  return (
    <>
      <UserMetadata
        user={data.nodeBySlugId}
        title={`${data.nodeBySlugId.firstName} ${data.nodeBySlugId.lastName}'s Presentations`}
      />

      <YStack gap='$5'>
        <UserPresentationsScreenUpcomingPresentationsSection
          user={data.nodeBySlugId}
        />

        <UserPresentationsScreenOtherPresentationsSection
          user={data.nodeBySlugId}
        />
      </YStack>
    </>
  )
}

export default UserPresentationsScreen
